import axios from 'axios';

import { getToken, removeToken } from '../utils/utils.ts';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_PATH = '/api/v1/';

export const api = axios.create({
  baseURL: `${API_BASE_URL}${API_PATH}`,
});

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => {
    if (response.status === 0 && !response.request?.responseURL?.startsWith('file:')) {
      return Promise.reject(
        new axios.AxiosError(
          'Request resolved with no response (status 0)',
          'ERR_NETWORK',
          response.config,
          response.request,
          response,
        ),
      );
    }
    return response;
  },
  error => {
    if (error.config?.skipAuthRedirect) {
      return Promise.reject(error);
    }
    if ([401, 403].includes(error.response?.status)) {
      removeToken();
      window.location.href = '/login/';
    }
    return Promise.reject(error);
  },
);
